import angular, { ISCEService } from 'angular';

interface WrappedTrustedValue {
  $$unwrapTrustedValue(): string;
}

function isWrappedTrustedValue(value: unknown): value is WrappedTrustedValue {
  return typeof value === 'object' && value !== null && '$$unwrapTrustedValue' in value;
}

TrustAsHtmlFilterFactory.$inject = ['$sce'];

function TrustAsHtmlFilterFactory($sce: ISCEService) {
  function TrustAsHtmlFilter(value: string | WrappedTrustedValue) {
    if (isWrappedTrustedValue(value)) {
      return value;
    }

    return $sce.trustAsHtml(value);
  }

  return TrustAsHtmlFilter;
}

export const TrustAsHtmlFilterModule = angular
  .module('acme.common.filter.trustAsHtml', [])
  .filter('trustAsHtml', TrustAsHtmlFilterFactory).name;
